/**
 * Badge Component
 * Small status indicator with color variants
 *
 * @param {Object} props
 * @param {ReactNode} props.children - Badge content/text
 * @param {'success'|'warning'|'error'|'info'} props.variant - Color variant
 * @param {string} props.icon - Font Awesome icon class (optional)
 * @param {string} props.className - Additional CSS classes
 */
const Badge = ({
  children,
  variant = 'info',
  icon,
  className = ''
}) => {
  // Build CSS classes
  const classes = [
    'psyber-badge',
    `psyber-badge-${variant}`,
    className
  ].filter(Boolean).join(' ')

  return (
    <span className={classes}>
      {/* Icon (optional) */}
      {icon && (
        <i className={icon}></i>
      )}

      {/* Badge Content */}
      {children}
    </span>
  )
}

export default Badge
